<template>
  <a
    :href="href"
    target="_blank"
    class="text-primary-600 underline hover:text-primary-800 transition"
  >
    <slot />
  </a>
</template>

<script setup>
defineProps({
  href: {
    type: String,
    required: true,
  },
});
</script>
